import Chart from 'react-apexcharts';
import { ChartProps } from './chart-options';

export const DonutChart = (props: ChartProps): JSX.Element => <Chart {...props} type='donut' />;

export default DonutChart;
